(function () {
  'use strict';
  if (window.textualCollectionScroll) return;
  window.textualCollectionScroll = true;

  function initialize() {
    var root = document.querySelector('[data-infinite-collection]');
    if (!root || root.dataset.infiniteEnabled === 'false' || root.dataset.infiniteReady || !window.fetch || !window.IntersectionObserver) return;
    var grid = root.querySelector('[data-infinite-grid]');
    var pagination = root.querySelector('[data-infinite-pagination]');
    var controls = root.querySelector('[data-infinite-controls]');
    var more = root.querySelector('[data-infinite-next]');
    var status = root.querySelector('[data-infinite-status]');
    if (!grid || !pagination || !controls || !more) return;
    // These older theme controls bind once to the initial HTML. Keep normal
    // pagination if a merchant enables them, rather than append inert controls.
    if (grid.querySelector('.js-product-quick-view, .js-product-card-radio, .js-product-add-to-cart-button')) return;
    root.dataset.infiniteReady = 'true';
    var key = location.pathname + location.search;
    var firstPage = Number(root.dataset.page);
    var lastPage = firstPage;
    var next = more.getAttribute('href') || '';
    var busy = false;
    var failed = false;
    var restoring = true;
    var userMoved = false;
    root.dataset.infiniteRestoring = 'true';
    var leaving = false;
    var timer;
    var controller;
    var saved = history.state && history.state.textualCollection;
    if (!saved || saved.key !== key || saved.firstPage !== firstPage || saved.version !== 1) saved = null;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    function cards() { return Array.from(grid.querySelectorAll(':scope > [data-infinite-product]')); }
    function remember() {
      if (restoring || leaving) return;
      var header = document.querySelector('header');
      var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var anchor = cards().find(function (card) { return card.getBoundingClientRect().bottom > top; });
      var value = { version: 1, key: key, firstPage: firstPage, lastPage: lastPage, y: window.scrollY,
        anchor: anchor ? { id: anchor.dataset.infiniteProduct, offset: anchor.getBoundingClientRect().top } : null };
      try { history.replaceState(Object.assign({}, history.state, { textualCollection: value }), '', location.href); } catch (_) {}
    }
    function updateControls() {
      more.hidden = !next;
      if (next) more.setAttribute('href', next);
      more.setAttribute('aria-disabled', String(busy));
      more.textContent = failed ? 'Try loading more' : 'Load more';
      grid.setAttribute('aria-busy', String(busy));
      var end = root.querySelector('[data-infinite-end]');
      if (end) end.textContent = Math.min(Number(root.dataset.total), Number(root.dataset.offset) + cards().length);
    }
    async function loadNext() {
      if (busy || !next || leaving) return false;
      busy = true;
      failed = false;
      status.textContent = restoring ? 'Restoring your place…' : 'Loading more products…';
      updateControls();
      controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 15000);
      try {
        var url = new URL(next, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Invalid next page');
        url.searchParams.set('section_id', root.dataset.sectionId);
        var response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Page request failed');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var incoming = doc.querySelector('[data-infinite-collection]');
        if (!incoming || Number(incoming.dataset.page) !== lastPage + 1) throw new Error('Unexpected page');
        var incomingCards = Array.from(incoming.querySelectorAll('[data-infinite-grid] > [data-infinite-product]'));
        if (!incomingCards.length) throw new Error('Missing products');
        var existing = new Set(cards().map(function (card) { return card.dataset.infiniteProduct; }));
        var fragment = document.createDocumentFragment();
        incomingCards.forEach(function (card) {
          if (!existing.has(card.dataset.infiniteProduct)) {
            // Never run scripts from fetched section markup.
            card.querySelectorAll('script:not([type="application/json"])').forEach(function (script) { script.remove(); });
            existing.add(card.dataset.infiniteProduct);
            fragment.appendChild(document.importNode(card, true));
          }
        });
        grid.appendChild(fragment);
        lastPage = Number(incoming.dataset.page);
        next = incoming.querySelector('[data-infinite-next]').getAttribute('href') || '';
        pagination.innerHTML = incoming.querySelector('[data-infinite-pagination]').innerHTML;
        pagination.hidden = true;
        status.textContent = next ? '' : 'All products loaded.';
        document.dispatchEvent(new CustomEvent('loadLazyImages'));
        document.dispatchEvent(new CustomEvent('convertAllMoney'));
        document.dispatchEvent(new CustomEvent('collection:products-added', { detail: { container: grid, page: lastPage } }));
        return true;
      } catch (error) {
        if (!leaving) {
          failed = true;
          status.textContent = 'Unable to load more products. Try again or use the page links below.';
          pagination.hidden = false;
        }
        return false;
      } finally {
        clearTimeout(timeout);
        busy = false;
        controller = null;
        updateControls();
        remember();
      }
    }
    var observer = new IntersectionObserver(function (entries) {
      if (!restoring && !failed && entries.some(function (entry) { return entry.isIntersecting; })) loadNext();
    }, { rootMargin: '500px 0px' });
    more.addEventListener('click', function (event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      if (!restoring) loadNext();
    });
    window.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(remember, 150);
    }, { passive: true });
    ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
      window.addEventListener(type, function () { if (restoring) userMoved = true; }, { passive: true });
    });
    document.addEventListener('click', remember, true);
    window.addEventListener('pagehide', function () {
      remember();
      leaving = true;
      if (controller) controller.abort();
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        leaving = false;
        busy = false;
        updateControls();
        var position = history.state && history.state.textualCollection;
        if (position && position.key === key) restorePosition(position);
      }
    });
    function restorePosition(position) {
      var anchor = position.anchor && cards().find(function (card) { return card.dataset.infiniteProduct === position.anchor.id; });
      var y = anchor ? window.scrollY + anchor.getBoundingClientRect().top - position.anchor.offset : position.y;
      window.scrollTo({ top: Math.max(0, y || 0), behavior: 'instant' });
    }
    async function restore() {
      if (saved) {
        var target = Math.min(saved.lastPage, Number(root.dataset.pages));
        while (lastPage < target && await loadNext()) { /* Rebuild before restoring scroll. */ }
        if (document.readyState !== 'complete') await new Promise(function (resolve) {
          window.addEventListener('load', resolve, { once: true });
          setTimeout(resolve, 2000);
        });
        if (document.fonts) await Promise.race([document.fonts.ready, new Promise(function (resolve) { setTimeout(resolve, 1000); })]);
        await new Promise(function (resolve) { requestAnimationFrame(function () { requestAnimationFrame(resolve); }); });
        if (!leaving && !userMoved) restorePosition(saved);
      }
      restoring = false;
      root.dataset.infiniteRestoring = 'false';
      updateControls();
      remember();
      observer.observe(controls);
    }
    pagination.hidden = true;
    controls.hidden = false;
    updateControls();
    restore();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
